<template>
  <div class="modal-mask align-content-center">
    <div class="modal-wrapper">
      <div class="modal-container p-5 scrollable">
        <div class="modal-body">
          <b>{{ $t('transitionListModal.transitions.title') }}</b>
          <p v-if="transitionComment != null">{{ transitionComment }}</p>
          <div class="pt-5">
            <div v-for="transition in transitions" :key="transition.id" class="mb-3">
              <app-button variation="primary" class="mt-5" full-width :disabled="disabled || !actionEnabled"
                           layout="icon-label" icon="angle-righ-double" icon-position="right"
                           @click="onApplyTransition(transition.id)">
                {{ $t(transition.name) }}
              </app-button>
            </div>
          </div>
          <div class="row--cols--1 text-right pt-5">
            <app-button layout="label" btn-type="outline" @click="cancelTransition">
              {{ $t('transitionListModal.cancelTransitionButton.label') }}
            </app-button>
          </div>
          <TransitionCommentModal v-if="showCommentModal" @onDismiss="modalDismissHandler" @onConfirm="modalConfirmHandler" />
          <smtt-toast ref="errorToast" class="border-0" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TransitionCommentModal from "../siteDetails/TransitionCommentModal.vue";
import AppButton from '@/components/AppButton';

export default {
  'name': 'TransitionListModal',
  'components': { TransitionCommentModal, AppButton },
  'props': {

    'survey': Number,
    'roomId': Number,
    'assignmentId': Number,
    'site': Number,
    'transitions': Array,
    'onTransitioned': Event,
    'actionEnabled': Boolean,
    'transitionComment': String,
    'disabled': Boolean

  },
  'data': function () {
    return {
      'comment': null,
      'isConfirmDisabled': true,
      'showCommentModal': false,
    }
  },
  'methods': {
    cancelTransition() {
      this.$emit('onGoBackCancel')
    },
    'onApplyTransition': function (transition) {
      if (!(this.disabled || !this.actionEnabled)) {
        this.selectedTransition = transition
        this.showCommentModal = true
      }
    },
    'showErrorToast': function (message) {
      const errorMessage = message != null
          ? this.$t(message.code, message.params)
          : this.$t('error.default.connection.message')

      this.$emit('showError', errorMessage)
    },
    'modalDismissHandler': function () {
      this.selectedTransition = null
      this.showCommentModal = false
    },
    'modalConfirmHandler': function (comment) {
      if (this.selectedTransition != null) {
        this.$emit('onTransitioned', { transitionId: this.selectedTransition, comment: comment })
        this.selectedTransition = null
        this.showCommentModal = false
      }
    },
    closeHandler() {
      this.$emit('onDismiss');
    },
    confirmHandler() {
      if (!this.isConfirmDisabled) {
        this.$emit('onConfirm', this.comment);
      }
    },
    valueChange(e) {
      this.comment = e.detail.value
      this.isConfirmDisabled = this.comment.trim() === '';
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
  transition: opacity 0.3s ease;
  display: table;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  margin: 0 16px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  z-index: 1000;
}

.scrollable {
  overflow: auto;
  max-height: 90vh;
}

.fixed-row .col,.col--auto {
  height: 24px;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>